const googleMaps = () => {
	if ( $('#googleMap').length ) {
		initMap();
	}
};

const ZoomControl = (controlDiv, map) => {
    google.maps.event.addDomListener(zoomout, 'click', function() {
        const currentZoomLevel = map.getZoom();

        if (currentZoomLevel != 0) {
            map.setZoom(currentZoomLevel - 1);
        }     
    });

    google.maps.event.addDomListener(zoomin, 'click', function() {
        var currentZoomLevel = map.getZoom();
        if(currentZoomLevel != 21){
            map.setZoom(currentZoomLevel + 1);
        }
    });
};	

const initMap = () => {
    const mapLat = $('#googleMap').data('lat');
    const mapLng = $('#googleMap').data('lng');
    const location = {lat: mapLat, lng: mapLng};

    const map = new google.maps.Map(document.getElementById('googleMap'), {
        zoom: 15,
        center: location,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControl: false,
        styles: [
              {
                "featureType": "administrative.land_parcel",
                "stylers": [
                      {
                        "visibility": "off"
                      }
                ]
              },
              {
                "featureType": "administrative.neighborhood",
                "stylers": [
                      {
                        "visibility": "off"
                      }
                ]
              },
              {
                "featureType": "poi.business",
                "stylers": [
                      {
                        "visibility": "off"
                      }
                   ]
              },
              {
                "featureType": "poi.park",
                "elementType": "labels.text",
                "stylers": [
                      {
                        "visibility": "off"
                      }
                ]
              },
              {
                "featureType": "road",
                "elementType": "labels",
                "stylers": [
                      {
                        "visibility": "off"
                      }
                ]
              },
              {
                "featureType": "road.arterial",
                "elementType": "labels",
                "stylers": [
                      {
                        "visibility": "off"
                      }
                ]
              },
              {
                "featureType": "road.highway",
                "elementType": "labels",
                "stylers": [
                      {
                        "visibility": "off"
                      }
                   ]	
              },
              {
                "featureType": "road.local",
                "stylers": [
                      {
                           "visibility": "off"
                      }
                ]
              },
              {
                "featureType": "water",
                "elementType": "labels.text",
                "stylers": [
                      {
                        "visibility": "off"
                      }
                ]
              },
              {
                "elementType": "geometry",
                "stylers": [
                      {
                        "color": "#f5f5f5"
                      }
                ]
              },
              {
                "elementType": "labels.text.fill",
                "stylers": [
                      {
                        "color": "#616161"
                      }
                ]
              },
              {
                "elementType": "labels.text.stroke",
                "stylers": [
                      {
                        "color": "#f5f5f5"
                      }
                ]
              },
              {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                      {
                        "color": "#bdbdbd"
                      }
                ]
              },
              {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                  {
                        "color": "#eeeeee"
                      }
                   ]
              },
              {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                      {
                        "color": "#757575"
                      }
                ]
              },
              {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                      {
                        "color": "#e5e5e5"
                      }
                ]
              },
              {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                      {
                           "color": "#9e9e9e"
                      }
                ]
              },
              {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                      {
                        "color": "#ffffff"
                      }
                   ]
              },
              {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                      {
                        "color": "#757575"
                      }
                ]
              },
              {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                      {
                        "color": "#dadada"
                      }
                ]
              },
              {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                      {
                        "color": "#616161"
                      }
                ]
              },
              {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                      {
                        "color": "#9e9e9e"
                      }
                ]
              },
              {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                      {
                        "color": "#e5e5e5"
                      }
                ]
              },
              {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                      {
                           "color": "#eeeeee"
                      }
                ]
              },
              {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                      {
                           "color": "#c9c9c9"
                      }
                ]
              },
              {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                      {
                        "color": "#9e9e9e"
                      }
                ]
             }
        ]					
    });

    const marker = new google.maps.Marker({
        position: location,
        map: map,
        icon: '/wp-content/themes/peak/library/images/map-pin.png',
    });

    /* Create the DIV to hold the control and call the ZoomControl() constructor passing in this DIV. */
    const customZoomDiv = document.createElement('div');
    const customZoom = new ZoomControl(customZoomDiv, map);	
};	